"use client";
import { Modal } from "react-bootstrap";
import Image from "next/image";
import classes from "./PayInInstallmentsModal.module.css";
import { X } from "react-feather";

const PayInInstallmentsModal = (props) => {
  const { payInInstallmentsModal, setPayInInstallmentsModal, price } = props;

  return (
    <>
      <Modal
        show={payInInstallmentsModal}
        onHide={() => setPayInInstallmentsModal(false)}
      >
        <div className={classes.main}>
          <X
            onClick={() => setPayInInstallmentsModal(false)}
            className={classes.closeIcon}
            strokeWidth={1}
          />
          <div className={classes.header}>
            <h3 className={classes.title2}> Pay in 4x with PayPal</h3>{" "}
            {/* <Image
							width={5}
							height={5}
							className={classes.paypalLogo}
							style={{ marginLeft: '2em', maxHeight: '5em', maxWidth: '10em' }}
							src={
								'https://ik.imagekit.io/kuj9zqlrx0or/Static/Paypal_logo.png?tr=w-200'
							}
							alt={'Paypal logo'}
						/> */}
          </div>
          <div className={classes.deliverySpec1}>
            <Image
              width={24}
              height={24}
              className={classes.paypalLogo1}
              src={"https://ik.imagekit.io/kuj9zqlrx0or/Static/Paypal-512.webp"}
              alt={"Paypal logo"}
            />
            <h6 className={classes.infoText}>
              Comfortably pay in installments with Paypal. Just select Paypal at
              checkout and choose &quot;Pay in 4&quot; as your payment method.
            </h6>
          </div>
          <div className={classes.footer}>
            Get this item by paying in 4x starting from{" "}
            <strong>
              $
              {(price / 4).toLocaleString(undefined, {
                maximumFractionDigits: 0,
              })}
              /month
            </strong>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PayInInstallmentsModal;
